const errorMessages = {
  EMPTY_FORM: "Please don't leave any of the fields above as blank.",
  '500-a': 'Network error. Please try again later.',
  '401-a': 'invalid credentials.',
  '403-a': "User's email is not yet verified.",
  '404-a': 'Invalid credentials.',
  '401-b': 'Username and Email is already taken.',
  '403-b': 'Username is already taken.',
  '404-b': 'Email is already taken.',
  '406-b': 'Invalid Email structure.',
  '500-b': 'Network error. Please try again later.',
  '501-b':
    'Your account was successfully created but email for account verification was not sent due to server error. Please log in, go to your account and proceed with email resending there.',
  '429': 'Too many requests, please try again after a few minutes.',
  INVALID_USERNAME: 'Invalid Username.',
  SPECIAL_CHARACTER: 'Please remove special characters.',
}

export default errorMessages
